import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { TOMOS, TOMO_FEATURES } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';
const TOMOS_IMG = HERO_IMAGE_URL;
export function TomosSection() {
  return <section id="tomos" className="bg-ivory py-12 sm:py-16" data-id="element-202" data-mp="1u2wqfa61bi5f">
      <div className="mx-auto max-w-5xl px-5" data-id="element-203" data-mp="1u4hkyzscn13a">
        <div className="text-center" data-id="element-204" data-mp="xdfnh2yfsa7f">
          <SectionTag data-id="element-205" data-mp="xeh2fiikpguf">La implementación</SectionTag>
          <h2 className="mt-4 font-display text-[1.8rem] font-semibold leading-tight text-charcoal sm:text-[2.6rem]" data-id="element-206" data-mp="11d7rd2cvxs6g">
            Los 6 tomos que te enseñan a implementar el sistema
          </h2>
          <p className="mx-auto mt-3 max-w-2xl font-sans text-sm leading-relaxed text-charcoal/70 sm:text-base" data-id="element-207" data-mp="1bcfay7a7qj20">
            Cada tomo resuelve una parte concreta del recorrido: desde que alguien te descubre hasta
            que se inscribe. Nada queda librado a la improvisación.
          </p>
          <p className="mt-2 font-sans text-sm font-semibold tabular-nums text-gold-deep sm:text-base" data-id="element-208" data-mp="2qoibvctay9qz">
            6 tomos · 350+ páginas · Todo el sistema resuelto
          </p>
        </div>

        <img src={TOMOS_IMG} alt="Los seis tomos del MegaPack Wellness Digital Pro junto a sus recursos digitales" width={1024} height={1024} loading="lazy" decoding="async" sizes="(max-width: 640px) 76vw, 400px" style={{
        aspectRatio: '1024 / 1024'
      }} className="mx-auto mt-7 block h-auto w-[76%] max-w-[380px] rounded-2xl border border-stone object-cover shadow-[0_28px_60px_-36px_rgba(28,27,25,0.4)]" data-id="element-209" data-mp="2hn0w5vjt4a2t" />

        <p className="mt-7 text-center text-[0.65rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-210" data-mp="1tyr6gijh326e">
          Perfil → Contenido → Cierre → Planificación
        </p>

        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-211" data-mp="1k01zvlx1145g">
          {TOMOS.map((tomo, i) => <motion.article key={tomo.num} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="flex gap-3 rounded-xl border border-stone bg-sand/50 p-4 transition-colors hover:border-gold/50" data-id="element-212" data-mp="1abmwpy08jxm9" data-mpi={i}>
              <span className="text-xl leading-none" aria-hidden data-id="element-213" data-mp="1t2e2kpl0l5vw">
                {tomo.emoji}
              </span>
              <div data-id="element-214" data-mp="1y0fm1bmcr77w">
                <p className="font-sans text-[0.6rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-215" data-mp="1y0z18kkmbhi8">
                  {tomo.num} · {tomo.title}
                </p>
                <h3 className="mt-1 font-display text-lg font-semibold leading-tight text-charcoal" data-id="element-216" data-mp="1oamkl3fxc8hd">
                  {tomo.outcome}
                </h3>
                <p className="mt-1 font-sans text-[0.78rem] leading-snug text-charcoal/60" data-id="element-217" data-mp="2gs00l9pnhf2b">
                  {tomo.desc}
                </p>
              </div>
            </motion.article>)}
        </div>

        <div id="incluye" className="mt-8 rounded-2xl border border-stone bg-sand/50 p-5 sm:p-6" data-id="element-218" data-mp="epx895srjxj">
          <h3 className="text-center font-display text-xl font-semibold text-charcoal" data-id="element-219" data-mp="f3m07rszy6ra">
            Cada tomo incluye
          </h3>
          <ul className="mt-4 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-220" data-mp="a4htr8xgin4n">
            {TOMO_FEATURES.map(f => <li key={f} className="flex items-start gap-2" data-id="element-221" data-mp="3ik1hjsfczdcb">
                <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold-deep" aria-hidden data-id="element-222" data-mp="3dlhrpgxn9heo" />
                <span className="font-sans text-[0.82rem] leading-snug text-charcoal/75" data-id="element-223" data-mp="3si8u7z2m798i">{f}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}